// Runtime values come from the environment's deployment-owned runtime-config.js.
// Build-time variables remain supported for local/customer development only.
const { read } = require("./runtimeConfig");
const API_URL = read("REACT_APP_API_URL", process.env.REACT_APP_API_URL, "/controller");
const SOCKET_URL = read("REACT_APP_SOCKET_URL", process.env.REACT_APP_SOCKET_URL, "/process");
const ANYPOINT_URL = read("REACT_APP_ANYPOINT_URL", process.env.REACT_APP_ANYPOINT_URL, "/");
const SOCKET_HOST = read("REACT_APP_SOCKET_HOST", process.env.REACT_APP_SOCKET_HOST, SOCKET_URL);
const origin = typeof window !== "undefined" ? window.location.origin : "http://localhost:8080";
const KEYCLOAK_URL = read("REACT_APP_KEYCLOAK_URL", process.env.REACT_APP_KEYCLOAK_URL, origin + "/auth");
const KEYCLOAK_REALM = read("REACT_APP_KEYCLOAK_REALM", process.env.REACT_APP_KEYCLOAK_REALM, "intelog");
const KEYCLOAK_CLIENT_ID = read("REACT_APP_KEYCLOAK_CLIENT_ID", process.env.REACT_APP_KEYCLOAK_CLIENT_ID, "intelog-frontend");
const PASSWORD_LOGIN = String(read("REACT_APP_PASSWORD_LOGIN", process.env.REACT_APP_PASSWORD_LOGIN, false)) === "true";

module.exports = {
    anypoint: ANYPOINT_URL,
    domain: API_URL,
    ENDPOINT: API_URL,
    SOCKET: SOCKET_URL,
    socketUrl: SOCKET_HOST,
    backendUrl: SOCKET_URL,
    passwordLogin: PASSWORD_LOGIN,
    keycloak: { url: KEYCLOAK_URL, realm: KEYCLOAK_REALM, clientId: KEYCLOAK_CLIENT_ID },
};
